import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import { showConfirm, showInfo } from '../../../../utills/sweetAlert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';

const cardStyle = {
  background: 'transparent',
  border: 'none',
  boxShadow: 'none',
  padding: 0,
  minWidth: 0,
  marginBottom: 0,
  fontFamily: 'Poppins, sans-serif',
};

const headerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 18,
};

const titleStyle = {
  fontWeight: 700,
  fontSize: 18,
  color: '#111',
  letterSpacing: 0.7,
};

const newBtnStyle = {
  background: 'linear-gradient(135deg, #00C853 0%, #43A047 100%)',
  color: '#fff',
  border: 'none',
  borderRadius: 8,
  padding: '10px 26px',
  fontWeight: 700,
  fontSize: 16,
  cursor: 'pointer',
  marginRight: 12,
  letterSpacing: 0.5,
  transition: 'all 0.3s ease',
  boxShadow: '0 2px 8px rgba(0, 200, 83, 0.3)',
};

const searchContainer = {
  position: 'relative',
  minWidth: 200,
  marginLeft: 8,
};

const searchInput = {
  width: 200,
  padding: '10px 36px 10px 38px',
  border: '1.5px solid #C8E6C9',
  borderRadius: 8,
  fontSize: 16,
  color: '#1B5E20',
  background: '#fff',
  fontFamily: 'inherit',
  outline: 'none',
  transition: 'border 0.3s',
};

const searchIconStyle = {
  position: 'absolute',
  left: 12,
  top: '50%',
  transform: 'translateY(-50%)',
  color: '#00C853',
  fontSize: 20,
  pointerEvents: 'none',
};

const actionStyle = {
  cursor: 'pointer',
  marginRight: 10,
  background: 'none',
  border: 'none',
  borderRadius: 6,
  padding: 4,
  color: '#757575',
  transition: 'all 0.3s ease',
};

const PermissionTable = ({ permissions, onEdit, onDelete, onNew }) => {
  const [search, setSearch] = useState('');
  const [hoveredAction, setHoveredAction] = useState({});

  const handleEdit = (permission) => {
    showInfo('Edit Permission', `Editing permission: ${permission.module_name}`);
    onEdit(permission);
  };

  const handleDelete = async (id, module_name) => {
    const confirmed = await showConfirm('Delete Permission', `Are you sure you want to delete permission: ${module_name}?`, 'Delete', 'Cancel');
    if (confirmed) onDelete(id);
  };

  const filteredPermissions = permissions.filter(p =>
    p.module_name && p.module_name.toLowerCase().includes(search.toLowerCase())
  );

  const columnHeaderStyle = {
    fontFamily: 'Poppins, sans-serif',
    fontSize: 15,
    fontWeight: 600,
    color: '#111',
  };
  const cellStyle = {
    fontFamily: 'Poppins, sans-serif',
    fontSize: 15,
    color: '#222',
  };

  const columns = [
    {
      name: 'Module Name',
      selector: row => row.module_name || 'No Name',
      sortable: true,
      style: cellStyle,
      headerStyle: columnHeaderStyle,
      width: '600px',
    },
    {
      name: 'Actions',
      cell: row => (
        <>
          <button 
            style={actionStyle} 
            onClick={() => handleEdit(row)} 
            title="Edit"
            onMouseEnter={() => setHoveredAction({ id: row.permission_id, type: 'edit' })}
            onMouseLeave={() => setHoveredAction({})}
          >
            <EditIcon fontSize="small" />
            {hoveredAction.id === row.permission_id && hoveredAction.type === 'edit' && (
              <span style={{ marginLeft: 4, color: '#1B5E20', fontWeight: 600 }}>Edit</span>
            )}
          </button>
          <button 
            style={actionStyle} 
            onClick={() => handleDelete(row.permission_id, row.module_name)} 
            title="Delete"
            onMouseEnter={() => setHoveredAction({ id: row.permission_id, type: 'delete' })}
            onMouseLeave={() => setHoveredAction({})}
          >
            <DeleteIcon fontSize="small" />
            {hoveredAction.id === row.permission_id && hoveredAction.type === 'delete' && (
              <span style={{ marginLeft: 4, color: '#d32f2f', fontWeight: 600 }}>Delete</span>
            )}
          </button>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      style: cellStyle,
      headerStyle: columnHeaderStyle,
    },
  ];

  return (
    <div style={cardStyle}>
      <div style={headerStyle}>
        <span style={titleStyle}>Permissions</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button 
            style={newBtnStyle} 
            onClick={onNew}
            onMouseEnter={(e) => {
              e.target.style.background = 'linear-gradient(135deg, #43A047 0%, #2E7D32 100%)';
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 4px 12px rgba(0, 200, 83, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'linear-gradient(135deg, #00C853 0%, #43A047 100%)';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 2px 8px rgba(0, 200, 83, 0.3)';
            }}
          >
            + New
          </button>
          <div style={searchContainer}>
            <SearchIcon style={searchIconStyle} />
            <input
              style={searchInput}
              type="text"
              placeholder="Search permissions..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="permission-table">
        <DataTable
          columns={columns}
          data={filteredPermissions}
          pagination
          highlightOnHover
          striped
          fixedHeader
          fixedHeaderScrollHeight="420px"
          noDataComponent={<div style={{ color: '#888', fontSize: 16 }}>No Permissions found.</div>}
          customStyles={{
            headRow: { style: { background: '#E8F5E9', fontWeight: 700 } },
            rows: { style: { minHeight: 48 } },
          }}
        />
      </div>
    </div>
  );
};

export default PermissionTable; 